/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ProjectCustomerProjectCustomer } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * ProjectsFromCustomerApi - axios parameter creator
 * @export
 */
export const ProjectsFromCustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets projects from customer.
         * @summary Get  projects from customer
         * @param {string} storeId The store identifier.
         * @param {string} customerId The customer id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFromCustomer: async (storeId: string, customerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('projectFromCustomer', 'storeId', storeId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('projectFromCustomer', 'customerId', customerId)
            const localVarPath = `/store/{storeId}/project/getProjectsFromCustomer`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer_Id'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsFromCustomerApi - functional programming interface
 * @export
 */
export const ProjectsFromCustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsFromCustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets projects from customer.
         * @summary Get  projects from customer
         * @param {string} storeId The store identifier.
         * @param {string} customerId The customer id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectFromCustomer(storeId: string, customerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCustomerProjectCustomer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectFromCustomer(storeId, customerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectsFromCustomerApi - factory interface
 * @export
 */
export const ProjectsFromCustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsFromCustomerApiFp(configuration)
    return {
        /**
         * Gets projects from customer.
         * @summary Get  projects from customer
         * @param {string} storeId The store identifier.
         * @param {string} customerId The customer id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectFromCustomer(storeId: string, customerId: string, options?: any): AxiosPromise<ProjectCustomerProjectCustomer> {
            return localVarFp.projectFromCustomer(storeId, customerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsFromCustomerApi - object-oriented interface
 * @export
 * @class ProjectsFromCustomerApi
 * @extends {BaseAPI}
 */
export class ProjectsFromCustomerApi extends BaseAPI {
    /**
     * Gets projects from customer.
     * @summary Get  projects from customer
     * @param {string} storeId The store identifier.
     * @param {string} customerId The customer id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsFromCustomerApi
     */
    public projectFromCustomer(storeId: string, customerId: string, options?: any) {
        return ProjectsFromCustomerApiFp(this.configuration).projectFromCustomer(storeId, customerId, options).then((request) => request(this.axios, this.basePath));
    }
}
